"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MorCurrencyRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.MorCurrencyRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.mor_currency.label',
    fallbackLabel: 'Currency',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'AUD', label: 'fields.enm.mor_currency.options.AUD', fallbackLabel: 'AUD' },
        { key: 'CAD', label: 'fields.enm.mor_currency.options.CAD', fallbackLabel: 'CAD' },
        { key: 'CHF', label: 'fields.enm.mor_currency.options.CHF', fallbackLabel: 'CHF' },
        { key: 'DKK', label: 'fields.enm.mor_currency.options.DKK', fallbackLabel: 'DKK' },
        { key: 'EUR', label: 'fields.enm.mor_currency.options.EUR', fallbackLabel: 'EUR' },
        { key: 'GBP', label: 'fields.enm.mor_currency.options.GBP', fallbackLabel: 'GBP' },
        { key: 'NOK', label: 'fields.enm.mor_currency.options.NOK', fallbackLabel: 'NOK' },
        { key: 'PLN', label: 'fields.enm.mor_currency.options.PLN', fallbackLabel: 'PLN' },
        { key: 'SEK', label: 'fields.enm.mor_currency.options.SEK', fallbackLabel: 'SEK' },
        { key: 'USD', label: 'fields.enm.mor_currency.options.USD', fallbackLabel: 'USD' },
        { key: 'NZD', label: 'fields.enm.mor_currency.options.NZD', fallbackLabel: 'NZD' },
        { key: 'MXN', label: 'fields.enm.mor_currency.options.MXN', fallbackLabel: 'MXN' },
        { key: 'CZK', label: 'fields.enm.mor_currency.options.CZK', fallbackLabel: 'CZK' },
        { key: 'CNY', label: 'fields.enm.mor_currency.options.CNY', fallbackLabel: 'CNY' },
    ],
    trackFieldValueWithAnalytics: false,
};
